import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
import AbstractPoll from './Poll/AbstractPoll';
import PollState from '../states/PollState';
export default class PostPoll extends AbstractPoll {
  className() {
    return 'Post-poll';
  }
  createState() {
    return new PollState(this.attrs.poll, this.attrs.post);
  }
  controlItems() {
    const items = new ItemList();
    const poll = this.attrs.poll;
    if (poll.canSeeVoters()) {
      items.add('voters', m(Button, {
        onclick: this.state.showVoters,
        icon: "fas fa-poll"
      }, app.translator.trans('fof-polls.forum.public_poll')), 100);
    }
    if (poll.canEdit()) {
      items.add('edit', m(Button, {
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/EditPollModal', webpackMode: 'lazy-once' */ './EditPollModal'), {
          poll
        }),
        icon: "fas fa-pen"
      }, app.translator.trans('fof-polls.forum.moderation.edit')), 50);
    }
    if (poll.canDelete()) {
      items.add('delete', m(Button, {
        onclick: this.deletePoll.bind(this),
        icon: "fas fa-trash"
      }, app.translator.trans('fof-polls.forum.moderation.delete')), 0);
    }
    return items;
  }
  deletePoll() {
    if (!confirm(extractText(app.translator.trans('fof-polls.forum.moderation.delete_confirm')))) return;
    this.attrs.poll.delete().then(() => m.redraw.sync());
  }
}
flarum.reg.add('fof-polls', 'forum/components/PostPoll', PostPoll);flarum.reg.addChunkModule('206', '8987', 'fof-polls', 'forum/components/EditPollModal');